export const formatTime = (time: number | undefined): string => {
  if (typeof time === 'number' && !Number.isNaN(time) && Number.isFinite(time) && time >= 0) {
    const minutes = Math.floor(time / 60)
    const seconds = Math.floor(time % 60)
    const formatMinutes = minutes.toString().padStart(2, '0')
    const formatSeconds = seconds.toString().padStart(2, '0')
    return `${formatMinutes}:${formatSeconds}`
  }
  return '00:00'
}

export const getPercentage = (currentTime: number, duration: number): number => {
  if (currentTime && duration) {
    return (currentTime / duration) * 100
  }
  return 0
}
